var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.175 17.2324C16.675 17.2324 16.2917 17.0201 16.025 16.5954C15.7583 16.1701 15.7417 15.7324 15.975 15.2824L17 13.2324H15C14.45 13.2324 13.9793 13.0364 13.588 12.6444C13.196 12.2531 13 11.7824 13 11.2324V8.23242C13 7.68242 13.196 7.21176 13.588 6.82042C13.9793 6.42842 14.45 6.23242 15 6.23242H18C18.55 6.23242 19.021 6.42842 19.413 6.82042C19.8043 7.21176 20 7.68242 20 8.23242V12.7574C20 12.9074 19.9873 13.0618 19.962 13.2204C19.9373 13.3784 19.8833 13.5241 19.8 13.6574L18.375 16.4824C18.2583 16.7158 18.0917 16.8991 17.875 17.0324C17.6583 17.1658 17.425 17.2324 17.175 17.2324ZM8.175 17.2324C7.675 17.2324 7.29167 17.0201 7.025 16.5954C6.75833 16.1701 6.74167 15.7324 6.975 15.2824L8 13.2324H6C5.45 13.2324 4.97933 13.0364 4.588 12.6444C4.196 12.2531 4 11.7824 4 11.2324V8.23242C4 7.68242 4.196 7.21176 4.588 6.82042C4.97933 6.42842 5.45 6.23242 6 6.23242H9C9.55 6.23242 10.021 6.42842 10.413 6.82042C10.8043 7.21176 11 7.68242 11 8.23242V12.7574C11 12.9074 10.9877 13.0618 10.963 13.2204C10.9377 13.3784 10.8833 13.5241 10.8 13.6574L9.375 16.4824C9.25833 16.7158 9.09167 16.8991 8.875 17.0324C8.65833 17.1658 8.425 17.2324 8.175 17.2324Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteicon);
export default __webpack_public_path__ + "static/media/quoteicon.2a11c18641427bbe9086e5b2457079b6.svg";
export { ForwardRef as ReactComponent };